module.exports = "<mat-card>\n  <mat-card-content> Удалить пользователя {{user.name}}?</mat-card-content>\n  <mat-card-actions>\n      <button (click)=\"delete()\" type=\"button\"  color=\"warn\" mat-raised-button>Удалить</button>\n      <button type=\"button\" (click)=\"dialogRef.close()\" color=\"primary\" mat-raised-button>Отмена</button>\n    </mat-card-actions>\n</mat-card>"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/delete-user/delete-user.component.html
// module id = ./src/app/users/delete-user/delete-user.component.html
// module chunks = main